import { useBusinessContext, useFeature } from '@context'
import { useLocalStorage } from '@hooks'
import { BusinessForms, IBusiness } from '@query'
import { nojaAdDismissedCacheKey, nojaFormSentCacheKey } from '@root/utils'

export const isBusinessExcludedFromNojaAd = (business: IBusiness | undefined): boolean => {
  return business?.form === BusinessForms.DEMO || business?.form === BusinessForms.FI_NY
}

/**
 * Hook to determine if the Noja advertisement should be shown.
 */
export const useIsNojaAdActive = (): boolean => {
  const { slug, data: business } = useBusinessContext()
  const { enabled: nojaEnabled } = useFeature('noja')

  const [hasSentNojaForm] = useLocalStorage(nojaFormSentCacheKey(slug), false)
  const [hasDismissedNojaAd] = useLocalStorage(nojaAdDismissedCacheKey(slug), false)
  const isExcludedFromNojaAd = isBusinessExcludedFromNojaAd(business)

  return (
    nojaEnabled &&
    !!business?.is_new_invoicer &&
    !hasSentNojaForm &&
    !isExcludedFromNojaAd &&
    !hasDismissedNojaAd
  )
}
